import { supabase } from "@/integrations/supabase/client";
import { isInternalTraffic, readCampaign } from "./shopCampaigns";
const KEY = "sto-shopping-session";
type Context = ReturnType<typeof readCampaign> & { session_id: string; internal: boolean; referrer: string; updated: number };
export function shoppingContext(): Context | null {
  try {
    const now = Date.now();
    const saved = JSON.parse(sessionStorage.getItem(KEY) || "null") as Context | null;
    const tags = readCampaign(location.search);
    let referrer = "";
    try { referrer = document.referrer ? new URL(document.referrer).hostname : ""; } catch { /* no valid referrer */ }
    const own = ["sugartownorganics.com", "www.sugartownorganics.com", "sugartownnaturals.com", "sugartownnaturals.lovable.app"].includes(referrer);
    const ctx: Context = saved && now - saved.updated < 30 * 60 * 1000 ? saved : { ...tags, session_id: crypto.randomUUID(), internal: false, referrer: own ? "" : referrer, updated: now };
    if (tags.source) Object.assign(ctx, tags);
    ctx.internal = ctx.internal || isInternalTraffic(location.hostname, location.pathname, tags.medium);
    ctx.updated = now;
    sessionStorage.setItem(KEY, JSON.stringify(ctx));
    return ctx;
  } catch { return null; }
}
export type ShoppingEvent = "page_view" | "shop_visit" | "view_item" | "add_to_cart" | "begin_checkout" | "engagement";
export function trackShopping(event: ShoppingEvent, data: { product_handle?: string; variant_id?: string; quantity?: number; active_seconds?: number } = {}): void {
  const context = shoppingContext();
  if (!context) return;
  // Best effort only: never block shopping; no email, address or private URL is sent.
  const body = JSON.stringify({ event, context, page_path: location.pathname, ...data });
  void supabase.auth.getSession().then(({data:session}) => fetch(`${import.meta.env.VITE_SUPABASE_URL}/functions/v1/shop-analytics`, {
    method: "POST", keepalive: true,
    headers: { "Content-Type": "application/json", apikey: import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY, Authorization: `Bearer ${session.session?.access_token || import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY}` },
    body,
  })).catch(() => undefined);
}